import {PaymentPeriod} from "../../libs/enum/payment-period.enum";

export class FeaturePriceDto {

  public price!: number;
  public priceMinimum: number | undefined;
  public currencyCode!: string;
  public priceYearly: number | undefined;
  public paymentPeriod!: PaymentPeriod;

  constructor(init?: Partial<FeaturePriceDto> | undefined) {
    Object.assign(this, init);
  }
}
